module.exports = __webpack_public_path__ + "static/img/order-mobile-1.4d66ce1a.png";